import { Link } from "react-router-dom";

export default function CookiePolicy() {
  return (
    <article data-testid="cookie-policy-page" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 font-ui text-[#1A362D] leading-relaxed">
      <p className="label-eyebrow text-[#C05C45]">Informativa</p>
      <h1 className="mt-2 font-display text-4xl sm:text-5xl tracking-tight">Cookie Policy</h1>
      <p className="mt-6 text-[#5C6B64]">
        Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT", { year: "numeric", month: "long" })}
      </p>

      <section className="mt-10 space-y-4">
        <h2 className="font-display text-2xl mt-8">Cosa sono i cookie</h2>
        <p>
          I cookie sono piccoli file di testo che i siti web memorizzano sul tuo dispositivo. Servono a far funzionare
          il sito, ricordare le tue preferenze, misurare l'audience e — se acconsenti — personalizzare la pubblicità.
          Oltre ai cookie, usiamo tecnologie simili come local storage, pixel di tracciamento e identificatori
          pubblicitari; nella presente policy per semplicità useremo il termine generico "cookie".
        </p>

        <h2 className="font-display text-2xl mt-8">Categorie di cookie usati su Per manina</h2>

        <h3 className="font-display text-xl mt-6 mb-2">1. Cookie tecnici essenziali</h3>
        <p>
          Sono necessari per il funzionamento del sito e la sicurezza. <strong>Non richiedono consenso</strong>
          (base giuridica: legittimo interesse, art. 6.1.f GDPR).
        </p>
        <div className="overflow-x-auto mt-3">
          <table className="w-full text-sm border border-[#E8E6E1]">
            <thead className="bg-[#FBFAF7]">
              <tr>
                <th className="border border-[#E8E6E1] px-3 py-2 text-left">Nome</th>
                <th className="border border-[#E8E6E1] px-3 py-2 text-left">Fornitore</th>
                <th className="border border-[#E8E6E1] px-3 py-2 text-left">Finalità</th>
                <th className="border border-[#E8E6E1] px-3 py-2 text-left">Durata</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-[#E8E6E1] px-3 py-2"><code>permanina_session_token</code></td>
                <td className="border border-[#E8E6E1] px-3 py-2">Per manina</td>
                <td className="border border-[#E8E6E1] px-3 py-2">Mantiene l'utente autenticato tra le sessioni</td>
                <td className="border border-[#E8E6E1] px-3 py-2">30 giorni</td>
              </tr>
              <tr>
                <td className="border border-[#E8E6E1] px-3 py-2"><code>permanina_consent</code></td>
                <td className="border border-[#E8E6E1] px-3 py-2">Per manina</td>
                <td className="border border-[#E8E6E1] px-3 py-2">Memorizza le preferenze cookie</td>
                <td className="border border-[#E8E6E1] px-3 py-2">6 mesi</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-display text-xl mt-8 mb-2">2. Cookie analitici (anonimi, previo consenso)</h3>
        <p>
          Si attivano solo se accetti dal banner cookie. Ci aiutano a capire come viene usato il sito in forma aggregata,
          per migliorare contenuti e navigazione. <strong>Base giuridica: consenso</strong> (art. 6.1.a GDPR).
        </p>
        <div className="overflow-x-auto mt-3">
          <table className="w-full text-sm border border-[#E8E6E1]">
            <thead className="bg-[#FBFAF7]">
              <tr>
                <th className="border border-[#E8E6E1] px-3 py-2 text-left">Nome</th>
                <th className="border border-[#E8E6E1] px-3 py-2 text-left">Fornitore</th>
                <th className="border border-[#E8E6E1] px-3 py-2 text-left">Finalità</th>
                <th className="border border-[#E8E6E1] px-3 py-2 text-left">Durata</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-[#E8E6E1] px-3 py-2"><code>_ga</code>, <code>_ga_*</code></td>
                <td className="border border-[#E8E6E1] px-3 py-2">Google Analytics 4</td>
                <td className="border border-[#E8E6E1] px-3 py-2">Identificativo anonimo visitatore (IP mascherato)</td>
                <td className="border border-[#E8E6E1] px-3 py-2">2 anni</td>
              </tr>
              <tr>
                <td className="border border-[#E8E6E1] px-3 py-2"><code>_gid</code></td>
                <td className="border border-[#E8E6E1] px-3 py-2">Google Analytics 4</td>
                <td className="border border-[#E8E6E1] px-3 py-2">Identifica sessioni giornaliere aggregate</td>
                <td className="border border-[#E8E6E1] px-3 py-2">24 ore</td>
              </tr>
              <tr>
                <td className="border border-[#E8E6E1] px-3 py-2"><code>ph_*</code></td>
                <td className="border border-[#E8E6E1] px-3 py-2">PostHog</td>
                <td className="border border-[#E8E6E1] px-3 py-2">Analisi comportamenti aggregati per bug fix e UX</td>
                <td className="border border-[#E8E6E1] px-3 py-2">1 anno</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-display text-xl mt-8 mb-2">3. Cookie di profilazione pubblicitaria (previo consenso)</h3>
        <p>
          Si attivano solo se accetti dal banner cookie. Permettono ai partner pubblicitari di mostrarti annunci
          più rilevanti, misurarne l'efficacia e prevenire frodi. <strong>Base giuridica: consenso</strong> (art. 6.1.a GDPR).
        </p>
        <div className="overflow-x-auto mt-3">
          <table className="w-full text-sm border border-[#E8E6E1]">
            <thead className="bg-[#FBFAF7]">
              <tr>
                <th className="border border-[#E8E6E1] px-3 py-2 text-left">Fornitore</th>
                <th className="border border-[#E8E6E1] px-3 py-2 text-left">Finalità</th>
                <th className="border border-[#E8E6E1] px-3 py-2 text-left">Durata max</th>
                <th className="border border-[#E8E6E1] px-3 py-2 text-left">Policy</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-[#E8E6E1] px-3 py-2">Google AdSense / Ad Manager</td>
                <td className="border border-[#E8E6E1] px-3 py-2">Pubblicità personalizzata, frequency capping, antifrode</td>
                <td className="border border-[#E8E6E1] px-3 py-2">2 anni</td>
                <td className="border border-[#E8E6E1] px-3 py-2">
                  <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer" className="text-[#C05C45] underline">Google Ads</a>
                </td>
              </tr>
              <tr>
                <td className="border border-[#E8E6E1] px-3 py-2">Meta Pixel (quando attivo)</td>
                <td className="border border-[#E8E6E1] px-3 py-2">Retargeting campagne Facebook/Instagram, misurazione conversioni</td>
                <td className="border border-[#E8E6E1] px-3 py-2">90 giorni</td>
                <td className="border border-[#E8E6E1] px-3 py-2">
                  <a href="https://www.facebook.com/privacy/policies/cookies/" target="_blank" rel="noopener noreferrer" className="text-[#C05C45] underline">Meta</a>
                </td>
              </tr>
              <tr>
                <td className="border border-[#E8E6E1] px-3 py-2">Vendor IAB TCF 2.2</td>
                <td className="border border-[#E8E6E1] px-3 py-2">Pubblicità programmatica di terze parti (DSP, SSP, ad exchange)</td>
                <td className="border border-[#E8E6E1] px-3 py-2">Variabile per vendor</td>
                <td className="border border-[#E8E6E1] px-3 py-2">
                  <a href="https://iabeurope.eu/transparency-consent-framework/" target="_blank" rel="noopener noreferrer" className="text-[#C05C45] underline">IAB Europe</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-4">
          L'elenco <strong>completo e aggiornato</strong> dei vendor pubblicitari (circa 800 operatori certificati IAB)
          è consultabile direttamente nel banner cookie, cliccando su <em>"Opzioni"</em> o <em>"Gestisci preferenze"</em>.
          Per ciascun vendor puoi vedere le finalità dichiarate e scegliere individualmente se autorizzarlo.
        </p>

        <h2 className="font-display text-2xl mt-8">Come gestire o revocare il consenso</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <strong>Prima volta che visiti il sito</strong>: appare il banner cookie. Puoi scegliere di accettare tutto,
            rifiutare tutto, o personalizzare le tue preferenze per singola categoria/vendor.
          </li>
          <li>
            <strong>In qualsiasi momento</strong>: clicca sul link <em>"Preferenze cookie"</em> in fondo a ogni pagina
            per modificare o revocare i tuoi consensi.
          </li>
          <li>
            <strong>Dal tuo browser</strong>: puoi sempre cancellare manualmente i cookie dalle impostazioni browser.
            Guide ufficiali:{" "}
            <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#C05C45] underline">Chrome</a>,{" "}
            <a href="https://support.mozilla.org/kb/elimina-cookie-rimuovere-informazioni-siti-web" target="_blank" rel="noopener noreferrer" className="text-[#C05C45] underline">Firefox</a>,{" "}
            <a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#C05C45] underline">Safari</a>,{" "}
            <a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-[#C05C45] underline">Edge</a>.
          </li>
        </ul>

        <h2 className="font-display text-2xl mt-8">Trasferimenti di dati extra-UE</h2>
        <p>
          Alcuni fornitori di cookie (Google, Meta, PostHog) hanno sede negli Stati Uniti. Il trasferimento dei dati
          avviene nel rispetto delle garanzie previste dal Capo V del GDPR, tramite il framework{" "}
          <strong>EU-US Data Privacy Framework</strong> o <strong>Standard Contractual Clauses</strong> approvate
          dalla Commissione Europea.
        </p>

        <h2 className="font-display text-2xl mt-8">Collegamenti utili</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Documento completo: <Link to="/info/privacy" className="text-[#C05C45] underline">Privacy Policy</Link></li>
          <li>Termini di servizio: <Link to="/info/termini" className="text-[#C05C45] underline">Termini e Condizioni</Link></li>
          <li>Autorità di controllo:{" "}
            <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" className="text-[#C05C45] underline">Garante per la protezione dei dati personali</a>
          </li>
        </ul>

        <p className="mt-8 text-sm text-[#5C6B64]">
          Per domande o segnalazioni scrivi a{" "}
          <a href="mailto:info@permanina.it" className="text-[#C05C45] underline">info@permanina.it</a>.
        </p>
      </section>
    </article>
  );
}
